import {CountUp} from "countup.js";

export const initCounter = () => {

    const observedElements = document.querySelectorAll(".key-number .value")

    //console.log(observedElements)

    const callback = (entries, observer) => {
        const counter_options = {
            separator: '', // .
            decimal: '', // ,
        };

        entries.forEach((entry) => {
            let elm = entry.target;
            let value = elm.dataset.number;
            if (entry.isIntersecting) {
                let elm_counter = new CountUp(elm, value, counter_options);
                if (!elm_counter.error) {
                    elm_counter.start();
                } else {
                    console.error(elm_counter.error);
                }
            } else {
                //elm.classList.remove("is-inview");
            }
        })
    }

    const options = {
        threshold: 0.1
    }

    const observer = new IntersectionObserver(callback, options)

    observedElements.forEach( element => {
        observer.observe(element)
    })
}
